import { render, staticRenderFns } from "./PointListChargeLayout.vue?vue&type=template&id=5ffa27bf&scoped=true&"
import script from "./PointListChargeLayout.vue?vue&type=script&lang=js&"
export * from "./PointListChargeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa27bf",
  null
  
)

export default component.exports